import {countLevelBits, levelKey} from './seenAreaFormat';

/**
 * H7: per-level share of tissue tiles seen, then the plain average over levels that have tissue.
 * `levels` are the reachable view levels [{kind, level, label}]; only seen tiles that hold tissue count.
 * Returns {overall: 0..1 | null, levels: [{kind, level, label, seen, total, fraction}]}.
 */
export const computeSeenScore = (seenBytes, tissueBytes, layout, levels) => {
    const rows = [];
    for (const {kind, level, label} of levels) {
        const entry = layout.byKey[levelKey(kind, level)];
        if (!entry) continue;
        const total = countLevelBits(tissueBytes, entry);
        if (total === 0) continue;
        const seen = countLevelBits(seenBytes, entry, tissueBytes);
        rows.push({kind, level, label, seen, total, fraction: seen / total});
    }
    const overall = rows.length ? rows.reduce((sum, row) => sum + row.fraction, 0) / rows.length : null;
    return {overall, levels: rows};
};

export const formatPercent = (fraction) => fraction == null ? '–' : `${(Math.round(fraction * 1000) / 10).toFixed(1)}%`;
